import { Button } from '@/components/ui/button'
import { signInAgain, useTokenStore } from '@/lib/store'
import { LogIn } from 'lucide-react'
import { memo } from 'react'

/**
 * Shown instead of redirecting when silent renewal fails, so the open quote and
 * any unsaved edits stay on screen until the user chooses to sign in. Floats
 * over the page rather than blocking it: work can still be copied out first.
 */
export const SessionExpiredBanner = memo(function SessionExpiredBanner() {
  const sessionExpired = useTokenStore((state) => state.sessionExpired)
  if (!sessionExpired) return null

  return (
    <aside role="alert" className="fixed inset-x-3 top-3 z-50 mx-auto max-w-xl print:hidden">
      <div className="flex items-center gap-3 rounded-xl border border-destructive/30 bg-card p-2 pl-3 text-foreground shadow-xl">
        <LogIn className="size-5 shrink-0 text-destructive" aria-hidden />
        <p className="min-w-0 flex-1 text-sm leading-tight font-medium">
          Your sign-in expired. Save isn't possible until you sign in again.
        </p>
        <Button size="sm" className="shrink-0" onClick={() => void signInAgain()}>
          Sign in again
        </Button>
      </div>
    </aside>
  )
})
